/** Result of resolving and rendering a configured dynamic template. */
export enum TemplateLoadStatus {
    EMPTY,
    LOADED,
    ERROR
}
